import { Checkbox, Form } from 'antd';
import type { NamePath } from 'rc-field-form/es/interface';
import React from 'react';

type Props = {
  name: NamePath;
  disabled?: boolean;
};

export const EditableCheckboxField: React.FC<Props> = ({ name, disabled }) => (
  <Form.Item name={name} noStyle valuePropName="checked">
    <Checkbox disabled={disabled} />
  </Form.Item>
);
